import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/[locale]/(site)/service/angra-kop/page.tsx");
